import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { SiteHeader } from '@/components/ui/SiteHeader';
import { SiteFooter } from '@/components/ui/SiteFooter';
import Home from '@/pages/Home';
import Search from '@/pages/Search';
import Category from '@/pages/Category';
import Contact from '@/pages/Contact';
import BusinessDetail from '@/pages/BusinessDetail';
import NotFound from '@/pages/NotFound';

function AppLayout({ children, hideChrome = false }: { children: React.ReactNode; hideChrome?: boolean }) {
  if (hideChrome) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppLayout>
        <Home />
      </AppLayout>
    ),
  },
  {
    path: '/search',
    element: (
      <AppLayout>
        <Search />
      </AppLayout>
    ),
  },
  {
    path: '/category/:slug',
    element: (
      <AppLayout>
        <Category />
      </AppLayout>
    ),
  },
  {
    path: '/contact',
    element: (
      <AppLayout>
        <Contact />
      </AppLayout>
    ),
  },
  {
    path: '/india/:state/:city/:slug',
    element: (
      <AppLayout hideChrome>
        <BusinessDetail />
      </AppLayout>
    ),
  },
  {
    path: '*',
    element: (
      <AppLayout>
        <NotFound />
      </AppLayout>
    ),
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
